import http from 'hub-http/clients/apiClient';
export const CALLING_ORCH_SETTINGS_USER_API_V1 = '/calling-orchestration/v1/settings/user';
export const fetchCallingPreferencesProvider = () => {
  const url = CALLING_ORCH_SETTINGS_USER_API_V1;
  return http.get(url);
};